// Centralised dashboard IDs file
// Replace placeholder values with your actual Superset dashboard IDs (strings or numbers as required).

// Main dashboards
export const infinity_dashboard_id = '8984a5af-5c34-434b-ae8e-63fb14e870e0';
// Global dashboards
export const global_executive_dashboard_id = '082768b4-da9c-4af7-b92c-3a5556505679';

// Property-level universal dashboards (fallbacks)
// Only configured dashboards are exported; missing dashboard IDs are represented by undefined so the app falls through safely.
export const property_socio_impact_analysis_dashboard_id = 'c7015503-3202-4cfe-bcc3-295d132590d7';
export const property_socio_impact_regional_convergence_dashboard_id = 'e92fd69d-9441-40e9-aee4-717a8bf69903';

// Property-specific dashboards (per-property overrides)
// Keep the same keys used by `dashboard_one.js` for automatic compatibility.
export const property_specific_dashboards = {
  'Infinity': {
    'executive-summary': infinity_dashboard_id,
    'socio-impact-analysis': property_socio_impact_analysis_dashboard_id,
    'socio-impact-regional-convergence': property_socio_impact_regional_convergence_dashboard_id,
    'operations-overview': infinity_dashboard_id,
    'utilities': 'c8e75bf6-5033-4f98-8bf8-7abfaa0eb5ed',
    'energy': '1fa3e08b-1ebe-4f24-9511-312f179339fe',
    'parking-access': 'bf38a202-2c00-42b8-92a7-e0e8c6926e37',
    'security': '48a95c75-ce33-4c22-aabd-ec81d3976bc4',
    'connectivity': 'aa34b1e2-7eda-41f1-aa19-d5a0c5c11a1c',
    'insights-analytics': '07cae53e-6bc5-439a-8b77-c58b9902c4db'
  },
};

// A fallback mapping used in the dashboard component
export const property_dashboards = {
  'socio-impact-analysis': property_socio_impact_analysis_dashboard_id,
  'socio-impact-regional-convergence': property_socio_impact_regional_convergence_dashboard_id
};

// You can export a single default object if preferred by other modules:
export default {
  infinity_dashboard_id,
  global_executive_dashboard_id,
  property_dashboards
};